import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

type StandardTextInputProps = TextFieldProps & {
  onEnter?: () => void;
};

export const StandardTextInput: React.FC<StandardTextInputProps> = ({
  variant = "outlined",
  size = "medium",
  onEnter,
  onKeyDown,
  sx,
  ...rest
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && onEnter) {
      onEnter();
    }
    onKeyDown?.(e);
  };

  return (
    <TextField
      variant={variant}
      size={size}
      onKeyDown={handleKeyDown}
      sx={{
        "& .MuiOutlinedInput-root": {
          color: "white",
          backgroundColor: "rgba(255, 255, 255, 0.08)",
          borderRadius: 1,
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",
          "& fieldset": {
            borderColor: "rgba(255, 255, 255, 0.3)",
            borderWidth: 1.5,
            transition: "border-color 0.2s ease",
          },
          "&:hover fieldset": {
            borderColor: "rgba(255, 255, 255, 0.6)",
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255, 255, 255, 0.12)",
            boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.1)",
            "& fieldset": {
              borderColor: "rgba(255, 255, 255, 0.8)",
              borderWidth: 2,
            },
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(255, 255, 255, 0.03)",
            "& fieldset": {
              borderColor: "rgba(255, 255, 255, 0.12)",
            },
          },
        },
        "& .MuiInputBase-input": {
          color: "white",
          fontWeight: 500,
          "&::placeholder": {
            color: "rgba(255, 255, 255, 0.5)",
            opacity: 1,
          },
          "&.Mui-disabled": {
            WebkitTextFillColor: "rgba(255, 255, 255, 0.35)",
          },
        },
        "& .MuiInputLabel-root": {
          color: "rgba(255, 255, 255, 0.7)",
          "&.Mui-focused": {
            color: "white",
          },
          "&.Mui-disabled": {
            color: "rgba(255, 255, 255, 0.35)",
          },
        },
        "& .MuiFormHelperText-root": {
          color: "rgba(255, 255, 255, 0.6)",
          "&.Mui-error": {
            color: "#f87171",
          },
        },
        "& .MuiInputAdornment-root": {
          color: "rgba(255, 255, 255, 0.6)",
        },
        ...sx,
      }}
      {...rest}
    />
  );
};
